module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.current_page > 1 && _vm.tasks.length) ? _c('a', {
    staticClass: "prev-page clickable",
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/seta-esquerda.svg")
    }
  })]) : _vm._e(), (_vm.next_page && _vm.tasks.length) ? _c('a', {
    staticClass: "next-page clickable",
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/seta-direita.svg")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('br'), (_vm.loading) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _vm._e(), (!_vm.loading && _vm.tasks.length) ? _c('div', {
    staticClass: "task-list",
    attrs: {
      "id": "tasks"
    }
  }, [_vm._l((_vm.tasks), function(task, index) {
    return [(task.contact) ? _c('ozzy-task-item', {
      key: task.id,
      attrs: {
        "task": task
      },
      on: {
        "toggle-task-bar": _vm.bubbleUp,
        "removing": _vm.bubbleUp,
        "task-updated": _vm.taskUpdated
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), (!_vm.loading && !_vm.tasks.length) ? _c('div', {
    attrs: {
      "id": "message"
    }
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/ozzy-icone.svg")
    }
  }), _c('br'), _c('br'), _c('br'), _c('span', [_vm._v("Você não possui Ozzy Tasks no momento.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b1913c6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/ozzy_tasks/list.vue
// module id = 1135
// module chunks = 1